import React from "react";
import { toast } from "react-toastify";
import NumberFormat from "react-number-format";
import {
  createBasicFile,
  getFileDetail,
  getFilesByCreationAccess,
} from "../../actions/FileAction";
import CONSTANT from "../../constant";

class FileCreateStep1 extends React.Component {
  constructor(props) {
    super(props);
    const todaysDate = new Date().toISOString().split("T")[0];
    const userDetail = props.userDetail;
    const initialData = props.initialData || {};
    
    // Generate default prefix
    const defaultPrefix = `${userDetail.unitName}/${userDetail.departmentName}/`;
    
    this.state = {
      fileNumberPrefix: defaultPrefix,
      fileNumberInput: {
        name: "fileNumberInput",
        value: "",
        error: "",
        isRequired: true,
      },
      defaultfileNumber:
        initialData.fileNumber ||
        defaultPrefix,
      fileNumber: {
        name: "fileNumber",
        value:
          initialData.fileNumber ||
          defaultPrefix,
        error: "",
        isRequired: true,
      },
      dated: {
        name: "dated",
        value: initialData.dated || todaysDate,
        error: "",
        isRequired: true,
      },
      subject: {
        name: "subject",
        value: initialData.subject || "",
        error: "",
        isRequired: true,
      },
      financialImplication: {
        name: "financialImplication",
        value: initialData.financialImplication || "",
        error: "",
        isRequired: true,
      },
      showLoader: false,
      fileCreationUnits: {
        name: "fileCreationUnits",
        value: [],
        options: [],
        error: "",
        isRequired: false,
      },
      fileCreationDepartments: {
        name: "fileCreationDepartments",
        value: [],
        options: [],
        error: "",
        isRequired: false,
      },
      fileCreationDesignations: {
        name: "fileCreationDesignations",
        value: [],
        options: [],
        error: "",
        isRequired: false,
      },
    };
  }

  async componentDidMount() {
    try {
      let model = {
        units: this.props.userDetail?.fileCreationUnits,
        departments: this.props.userDetail?.fileCreationDepartments,
        designations: this.props.userDetail?.fileCreationDesignations,
      };
      const res = await getFilesByCreationAccess(model);
      if (res.status === "success") {
        this.setState((prev) => ({
          fileCreationUnits: {
            ...prev.fileCreationUnits,
            options: res.result.filesByUnits || [],
          },
          fileCreationDepartments: {
            ...prev.fileCreationDepartments,
            options: res.result.filesByDepartments || [],
          },
          fileCreationDesignations: {
            ...prev.fileCreationDesignations,
            options: res.result.filesByDesignations || [],
          },
        }));
      }
    } catch (err) {
      console.error("Error in componentDidMount:", err);
      this.setState({ showLoader: false });
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.initialData && this.props.initialData) {
      console.log("Loading initial data into form");
      
      // Extract user input from existing file number
      let userInputValue = "";
      if (this.props.initialData.fileNumber) {
        const prefix = `${this.props.userDetail.unitName}/${this.props.userDetail.departmentName}/`;
        if (this.props.initialData.fileNumber.startsWith(prefix)) {
          userInputValue = this.props.initialData.fileNumber.substring(prefix.length);
        } else {
          userInputValue = this.props.initialData.fileNumber;
        }
      }

      this.setState({
        fileNumberInput: {
          ...this.state.fileNumberInput,
          value: userInputValue,
        },
        fileNumber: {
          ...this.state.fileNumber,
          value: this.props.initialData.fileNumber || "",
        },
        dated: {
          ...this.state.dated,
          value: this.props.initialData.dated
            ? new Date(this.props.initialData.dated).toISOString().split("T")[0]
            : this.state.dated.value,
        },
        subject: {
          ...this.state.subject,
          value: this.props.initialData.subject || "",
        },
        financialImplication: {
          ...this.state.financialImplication,
          value: this.props.initialData.financialImplication || "",
        },
      });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    
    // Handle file number input change
    if (name === this.state.fileNumberInput.name) {
      this.setState((prevState) => ({
        fileNumberInput: {
          ...prevState.fileNumberInput,
          value: value,
          error: "",
        },
        fileNumber: {
          ...prevState.fileNumber,
          value: this.state.fileNumberPrefix + value,
          error: "",
        },
      }));
    } else {
      this.setState((prevState) => ({
        [name]: {
          ...prevState[name],
          value: value,
          error: "",
        },
      }));
    }
  };

  validateStep = () => {
    const { fileNumber, dated, subject, financialImplication } = this.state;
    let isValid = true;

    if (!fileNumber.value.trim()) {
      this.setState((prevState) => ({
        fileNumber: { ...prevState.fileNumber, error: "File # is required" },
      }));
      isValid = false;
    }

    if (!dated.value.trim()) {
      this.setState((prevState) => ({
        dated: { ...prevState.dated, error: "Date is required" },
      }));
      isValid = false;
    }

    if (!subject.value.trim()) {
      this.setState((prevState) => ({
        subject: { ...prevState.subject, error: "Subject is required" },
      }));
      isValid = false;
    }

    if (!financialImplication.value) {
      this.setState((prevState) => ({
        financialImplication: {
          ...prevState.financialImplication,
          error: "Financial implication is required",
        },
      }));
      isValid = false;
    }

    return isValid;
  };

  handleSubmit = async () => {
    if (!this.validateStep()) {
      return;
    }

    this.setState({ showLoader: true });

    const { fileNumber, dated, subject, financialImplication } = this.state;
    const { userDetail, onStepComplete, action } = this.props;

    const model = {
      fileNumber: fileNumber.value,
      dated: dated.value,
      subject: subject.value,
      financialImplication: financialImplication.value || "0",
      saveAsDraft: true,
      sheetType: "green",
      userCode: userDetail.code,
      fileCode: this.props.fileCode,
    };
    if (action) {
      model.action = action;
    }

    try {
      const res = await createBasicFile(model);
      if (res.status === CONSTANT.static.apiStatus.success) {
        if (this.props.fileCode) {
          toast.success("File updated successfully", {
            position: "top-right",
            autoClose: 3000,
          });
        } else {
          toast.success("File created successfully", {
            position: "top-right",
            autoClose: 3000,
          });
        }
        onStepComplete({
          fileCode: res.result.fileCode || res.result.code,
          fileNumber: res.result.fileNumber,
          dated: dated.value,
          subject: subject.value,
          financialImplication: financialImplication.value,
          nextStep: res.result.nextStep,
          stepData: res.result,
        });
      } else {
        toast.error(res.error || "Failed to create file", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Error creating file. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      this.setState({ showLoader: false });
    }
  };

  onMultiChange = (e) => {
    const { name, options } = e.target;

    const selectedValues = Array.from(options)
      .filter((opt) => opt.selected)
      .map((opt) => opt.value);

    const selectedNames = Array.from(options)
      .filter((opt) => opt.selected)
      .map((opt) => opt.text);

    this.setState(
      (prev) => ({
        [name]: {
          ...prev[name],
          value: selectedValues,
          nameValue: selectedNames,
          error: "",
        },
      }),
      () => {
        this.updateFileNumber();
      }
    );
  };

  updateFileNumber = () => {
    const {
      fileCreationUnits,
      fileCreationDepartments,
      fileCreationDesignations,
    } = this.state;

    const unit = fileCreationUnits.value[0] || "";
    const department = fileCreationDepartments.value[0] || "";
    
    let newPrefix = "";
    if (unit && department) {
      newPrefix = `${unit}/${department}/`;
    } else if (unit) {
      newPrefix = `${unit}/`;
    } else if (department) {
      newPrefix = `${department}/`;
    } else {
      newPrefix = this.state.fileNumberPrefix;
    }

    // Update prefix and file number
    this.setState((prev) => ({
      fileNumberPrefix: newPrefix,
      fileNumber: { 
        ...prev.fileNumber, 
        value: newPrefix + prev.fileNumberInput.value 
      },
    }));
  };

  resetFileNumber = () => {
    const defaultPrefix = `${this.props.userDetail.unitName}/${this.props.userDetail.departmentName}/`;
    
    this.setState((prev) => ({
      fileNumberPrefix: defaultPrefix,
      fileNumberInput: {
        ...prev.fileNumberInput,
        value: "",
      },
      fileNumber: {
        ...prev.fileNumber,
        value: defaultPrefix,
        error: "",
      },
      fileCreationUnits: {
        ...prev.fileCreationUnits,
        value: "",
        error: "",
      },
      fileCreationDepartments: {
        ...prev.fileCreationDepartments,
        value: "",
        error: "",
      },
      fileCreationDesignations: {
        ...prev.fileCreationDesignations,
        value: "",
        error: "",
      },
    }));
  };

  render() {
    const { 
      fileNumber, 
      dated, 
      subject, 
      financialImplication, 
      showLoader,
      fileNumberInput,
      fileNumberPrefix 
    } = this.state;

    return (
      <div className="step-content">
        <h5 className="mb-4 fw-semibold">Step 1: Basic Information</h5>
        
        <div className="row d-flex">
          {this.state.fileCreationUnits.options.length > 0 && (
            <div className="col-md-3">
              <div className="form-group">
                <label>Unit</label>
                <select
                  className="form-control"
                  name="fileCreationUnits"
                  value={this.state.fileCreationUnits.value}
                  onChange={this.onMultiChange}
                >
                  <option value="">Select Unit</option>
                  {this.state.fileCreationUnits.options.map((u) => (
                    <option key={u.code} value={u.name}>
                      {u.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {this.state.fileCreationDepartments.options.length > 0 && (
            <div className="col-md-3">
              <div className="form-group">
                <label>Department</label>
                <select
                  className="form-control"
                  name="fileCreationDepartments"
                  value={this.state.fileCreationDepartments.value}
                  onChange={this.onMultiChange}
                >
                  <option value="">Select Department</option>
                  {this.state.fileCreationDepartments.options.map((d) => (
                    <option key={d.code} value={d.name}>
                      {d.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {this.state.fileCreationDepartments.options.length > 0 && (
            <div className="col-md-3">
              <div className="form-group">
                <button
                  type="button"
                  className="btn btn-secondary mt-4"
                  onClick={this.resetFileNumber}
                >
                  Reset
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>
                File # <small className="text-danger">*</small>
              </label>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                <span style={{ 
                  fontWeight: 'bold', 
                  marginRight: '10px',
                  minWidth: '100px'
                }}>
                  {fileNumberPrefix}
                </span>
                <input
                  type="text"
                  className={`form-control ${
                    fileNumber.error ? "is-invalid" : ""
                  }`}
                  placeholder="Enter file number (e.g., 17695)"
                  name={fileNumberInput.name}
                  value={fileNumberInput.value}
                  onChange={this.handleChange}
                  style={{ flex: 1 }}
                />
              </div>
              <div className="mt-2">
                <small className="text-muted">
                  Full File #: <strong>{fileNumber.value}</strong>
                </small>
              </div>
              {fileNumber.error && (
                <div className="text-danger small mt-1">{fileNumber.error}</div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>
                Dated <small className="text-danger">*</small>
              </label>
              <input
                type="date"
                className={`form-control ${dated.error ? "is-invalid" : ""}`}
                name={dated.name}
                min={new Date().toISOString().split("T")[0]}
                max={new Date().toISOString().split("T")[0]}
                value={dated.value}
                disabled={true}
                onChange={this.handleChange}
              />
              {dated.error && (
                <div className="invalid-feedback">{dated.error}</div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>
                Subject <small className="text-danger">*</small>
              </label>
              <input
                type="text"
                className={`form-control ${subject.error ? "is-invalid" : ""}`}
                placeholder="Subject"
                name={subject.name}
                value={subject.value}
                onChange={this.handleChange}
              />
              {subject.error && (
                <div className="invalid-feedback">{subject.error}</div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>
                Financial implication <small className="text-danger">*</small>
              </label>
              <NumberFormat
                decimalScale={2}
                thousandSeparator={true}
                allowNegative={false}
                className={`form-control ${
                  financialImplication.error ? "is-invalid" : ""
                }`}
                placeholder="Must be greater than or equal to zero"
                name={financialImplication.name}
                value={financialImplication.value}
                onValueChange={(e) => {
                  this.handleChange({
                    target: {
                      name: financialImplication.name,
                      value: e.value,
                    },
                  });
                }}
              />
              {financialImplication.error && (
                <div className="invalid-feedback">
                  {financialImplication.error}
                </div>
              )}
            </div>
          </div>

          <div className="col-md-12 mt-4">
            <button
              type="button"
              className="create-btn-next"
              onClick={this.handleSubmit}
              disabled={showLoader}
            >
              {showLoader ? "Creating..." : "Create File"}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default FileCreateStep1;